import { render, staticRenderFns } from "./certs-pie-filter.vue?vue&type=template&id=6c1e4a28&"
import script from "./certs-pie-filter.vue?vue&type=script&lang=js&"
export * from "./certs-pie-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports